(() => {
  const modal = () => document.querySelector('[data-quick-view-modal]');
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-quick-view]');
    if (!button) return;
    event.preventDefault();
    const dialog = modal(); const content = dialog?.querySelector('[data-quick-view-content]');
    if (!dialog || !content) return;
    content.innerHTML = '<div class="empty-state">Loading…</div>';
    dialog.showModal();
    try {
      const separator = button.dataset.productUrl.includes('?') ? '&' : '?';
      const html = await fetch(`${button.dataset.productUrl}${separator}section_id=quick-view`).then((response) => response.text());
      content.innerHTML = html;
      window.initProductRoots?.(content);
    } catch (_) { content.innerHTML = '<div class="empty-state">Unable to load this product.</div>'; }
  });
  document.addEventListener('click', (event) => { if (event.target.closest('[data-quick-view-close]')) modal()?.close(); });
  modal()?.addEventListener('click', (event) => { if (event.target === modal()) modal().close(); });
})();
